module.exports = __webpack_public_path__ + "static/media/agenda.46092235.png";